// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_YEm","cls2":"ExportFormatModal-cls2_ah8 ExportFormatModal-cls1_YEm"};